<template>
  <v-dialog v-model="dialog" width="350">
    <v-card>
      <v-toolbar color="red-darken-3">
        <v-spacer />

        <v-btn
          variant="outlined"
          icon
          size="small"
          color="white"
          @click="dialog = false"
        >
          <v-icon> mdi-close </v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <p>
          {{ $t("price.initial_price") }}:
          <strong>
            {{ price.initial_price }}
          </strong>
        </p>
        <p>
          {{ $t("price.discounted_price") }}:
          <strong>
            {{ price.discounted_price }}
          </strong>
        </p>
        <p>
          {{ $t("price.discount_percentage") }}:

          <strong> {{ price.discount_percentage }}% </strong>
        </p>
        <p>
          {{ $t("price.logistic_price") }}:
          <strong>
            {{ price.logistic_price }}
          </strong>
        </p>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data: () => ({
    dialog: false,
    price: {},
  }),
  watch: {
    dialog(value) {
      if (!value) {
        this.price = {};
      }
    },
  },
  methods: {
    open(data) {
      this.dialog = true;
      this.price = data;
    },
  },
};
</script>
